module.exports = __webpack_public_path__ + "static/ramenspicy-4356989880af260556383dd335107d5b.jpg";